import {
  SEGMENT_EVENTS_SCHEMA_PREFIX,
  TRACK_EVENT_CART_VIEWED_SCHEMA,
  PAGE_EVENT_CART_VIEWED_SCHEMA,
} from './constants';

export const CART_VIEWED_EVENT_NAME = 'Cart Viewed';
export const CART_VIEWED_TRACK_EVENT_SCHEMA = `${SEGMENT_EVENTS_SCHEMA_PREFIX}${TRACK_EVENT_CART_VIEWED_SCHEMA}`;
export const CART_VIEWED_PAGE_EVENT_SCHEMA = `${SEGMENT_EVENTS_SCHEMA_PREFIX}${PAGE_EVENT_CART_VIEWED_SCHEMA}`;
